import * as React from 'react'
import { SVGProps } from 'react'
const SvgCheck: React.FC<React.SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m1.333 4 3.333 3.333L11.333.667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
export default SvgCheck
